import notEmptyAttribute from '@model/_shared/validator/notEmptyAttribute'
import isPositiveInteger from 'model/_shared/validator/isPositiveInteger'

export const validators = {
  serial: notEmptyAttribute,
  duration: isPositiveInteger,
}

export {
  validators as default,
}
